export default "__VITE_ASSET__fCb7lXE4__"